<template>
  <div class="fixbutton">
    <div class="wrapper">
      <img src="@/assets/reservation/top_icon.png" alt="" />
      <div class="button-box">
        <div
          class="button"
          v-for="(item, index) in links"
          :key="index"
          @click="handleClick(item)"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      links: [
        {
          link: "https://www.facebook.com/KarosOnlineTH/",
        },
        {
          link: "https://youtu.be/EnJJJ_HkquY",
        },
        {
          link: "https://discord.gg/sfXvD7sA7P",
        },
        {
          link: "https://www.facebook.com/sharer/sharer.php?u=https://karosth.panggame.com/reservation",
        },
      ],
    };
  },
  mounted() {
    this.isReservation();
  },
  methods: {
    handleClick(item) {
      window.open(item.link, "_blank").location;
    },
    isReservation(){
      if(window.location.pathname !== '/reservation'){
        this.links[3].link = "https://www.facebook.com/sharer/sharer.php?u=https://karosth.panggame.com";
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.fixbutton {
  position: fixed;
  z-index: 999;
  top: 50px;
  right: 50px;
  @media screen and (max-width: 900px) {
    top: 10px;
    right: 10px;
    width: 40%;
    text-align: center;
  }

  .wrapper {
    position: relative;
    @media screen and (max-width: 900px) {
      img {
        width: 100%;
      }
    }
    .button-box {
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      grid-gap: 7.5%;
      .button {
        flex: 1;
        aspect-ratio: 1/1;
        border-radius: 50%;
        cursor: pointer;
        margin-top: -5px;
        // background-color: rgba($color: #fff, $alpha: 0.5);
      }
    }
  }
}
</style>
